import { render } from "./SoftphoneSettingsView.vue?vue&type=template&id=1b1b369a&scoped=true"
import script from "./SoftphoneSettingsView.vue?vue&type=script&lang=js"
export * from "./SoftphoneSettingsView.vue?vue&type=script&lang=js"

import "./SoftphoneSettingsView.vue?vue&type=style&index=0&id=1b1b369a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b1b369a"]])

export default __exports__